module.exports = {"659010400":"胡杨河市核心区","659010500":"兵团一二五团","659010501":"兵团一二八团","659010502":"兵团一二九团","659010503":"兵团一三零团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659010.json
// module id = 3302
// module chunks = 0